import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { CustomerService } from './customer.service';
import { StrategiesPermissionsService } from '../../strategies/services/strategies-permissions.service';
import { of as observableOf, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CustomerResolveService implements Resolve<any> {
  constructor(
    private router: Router,
    private customerService: CustomerService,
    private strategiesPermissionsService: StrategiesPermissionsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    if (this.strategiesPermissionsService.isUserSuperAdmin()) {
      return observableOf([]);
    } else {
      return this.customerService.getCustomersWithChildStatus().pipe(map(
        res => {
          const customers = res;
          const firstCustomer = customers[0];
          if (customers.length === 1 && firstCustomer.childCount === 0) { // access to one inst with no children
            this.customerService.institution = firstCustomer;
            this.customerService.hasAccessToSingleInstitution = true;
            this.strategiesPermissionsService.populateUserInstitutionRoleAndPermissions();
            this.router.navigate([`/strategies/dashboard/${firstCustomer.id}`]);
            return null;
          } else {
            return customers;
          }
        },
        () => {
          return observableOf([]);
        }
      ));
    }
  }
}
